import { Card, CardContent } from '@/components/ui/card'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { formatPrice } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useProductDetailSafe } from '../../context/product-detail-context'

export const ProductPromotion = () => {
  const { product } = useProductDetailSafe()
  const t = useTranslations('product_detail.title')
  if (!product?.promotions || product?.promotions.length === 0) return null

  const promotionActive = product.promotions.filter(
    (promotion) => promotion.show_in_detail
  )

  if (!promotionActive || promotionActive.length === 0) return null

  return (
    <div className='relative mx-auto w-full max-w-4xl overflow-hidden rounded-xl border border-[#ff2459]'>
      {/* Header */}
      <div className='flex w-fit items-center rounded-br-lg rounded-tl-lg bg-[#ff2459] px-5 py-1 text-white'>
        <Image
          src={'/icons/icon-gift-promotion.svg'}
          alt='Logo'
          width={20}
          height={20}
          className='mr-2'
        />
        <div className='text-sm'>{t('special_offer_just_for_you')}</div>
      </div>

      <Carousel
        opts={{
          align: 'start',
          duration: 50,
          skipSnaps: true,
          dragFree: true,
        }}
        className='w-full px-4'
      >
        <CarouselContent className='gap-2 px-4 py-4'>
          {promotionActive.map((promotion) => (
            <CarouselItem
              key={promotion.id}
              className='basis-5/12 pl-0 will-change-transform sm:basis-1/4 lg:basis-1/3'
              data-product-id={promotion.id}
            >
              <Card
                key={promotion.id}
                className='flex-shrink-0 border-none shadow-none'
              >
                <CardContent className='p-0'>
                  <div className='mb-3 aspect-[0.75] overflow-hidden rounded-md bg-gray-100'>
                    <Image
                      src={ImageHelper.getImageUrl(promotion?.images[0]?.src)}
                      width={100}
                      height={100}
                      alt={promotion.title}
                      className='aspect-[0.75] h-full w-full object-cover'
                    />
                  </div>
                  <div className='line-clamp-2 font-criteria text-xs font-medium text-neutral-900 md:text-sm'>
                    {promotion.title}
                  </div>
                  <div className='text-xs text-neutral-600 md:text-sm'>
                    {promotion.description}
                  </div>
                  <div className='mt-2 flex items-baseline gap-2 pb-3'>
                    <span className='text-xs font-bold text-black'>
                      {formatPrice(promotion.regular_price)}
                    </span>
                    <span className='text-xs text-gray-400 line-through'>
                      {formatPrice(promotion.compare_price)}
                    </span>
                  </div>
                </CardContent>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
    </div>
  )
}

const CarouselNavigation = () => {
  return (
    <>
      <CarouselPrevious
        className='absolute left-4 top-1/2 h-8 w-8 -translate-y-1/2 sm:-left-4 xl:-left-10'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute right-4 top-1/2 h-8 w-8 -translate-y-1/2 sm:-right-4 xl:-right-10'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
